
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","width":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.746 8.027c.656.657 1.453.985 2.39.985.938 0 1.735-.328 2.391-.985.657-.656.985-1.453.985-2.39 0-.938-.328-1.735-.985-2.39-.656-.657-1.453-.985-2.39-.985-.938 0-1.735.328-2.39.984-.657.656-.985 1.453-.985 2.39 0 .938.328 1.735.984 2.391zm6.89.985l3.727 3.726-1.125 1.125-3.726-3.726v-.598L8.3 9.33c-.89.773-1.946 1.16-3.164 1.16-1.36 0-2.52-.47-3.48-1.407C.718 8.145.25 6.996.25 5.637c0-1.36.469-2.508 1.406-3.446C2.617 1.231 3.777.75 5.136.75c1.36 0 2.509.48 3.446 1.441.938.938 1.406 2.086 1.406 3.446 0 .492-.117 1.054-.351 1.687-.235.61-.504 1.102-.809 1.477l.211.21h.598z"}})])
          )
        }
      }
    